import { useEffect, useState } from 'react'


export const GLINT_DURATION = 600

export const glintWindow = (start, cycle) => [start, start + GLINT_DURATION / cycle]

export const smooth = (value) => {
  const t = Math.min(Math.max(value, 0), 1)
  return t * t * (3 - 2 * t)
}

// Glyphs stay drawn and still when the system asks for reduced motion
export const usePrefersReducedMotion = () => {
  const query = '(prefers-reduced-motion: reduce)'
  const [reduced, setReduced] = useState(() => window.matchMedia?.(query).matches ?? false)
  useEffect(() => {
    const media = window.matchMedia?.(query)
    if (!media) return undefined
    const onChange = (event) => setReduced(event.matches)
    media.addEventListener('change', onChange)
    return () => media.removeEventListener('change', onChange)
  }, [])
  return reduced
}

export const useAnimationFrame = (render, enabled) => {
  useEffect(() => {
    if (!enabled) return undefined
    let frame
    const start = performance.now()
    const tick = (now) => {
      if (render(now - start) === false) return
      frame = requestAnimationFrame(tick)
    }
    frame = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(frame)
  }, [render, enabled])
}
